//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const BackendCalculationDataSourceReuseHints: FeatureFlag = {"Id":"BackendCalculationDataSourceReuseHints","Label":"(KILL)[10.24]Generate backend datasource reuse hints","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Generate datasource reuse hints on form definition saves. When disabled, this service leaves existing hints unchanged and does not generate new hints.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
